import DragonbonesComponent from "Component/Dragonbones";
import { ILimit } from "Utility/MathHelper";
import { Random } from "Utility/Random";
import FarmEffectComponent from "./FarmEffect";

export namespace FarmEffectHelper {
    /**
     * Gets random interval time within provided component's range
     *  - If applicable, the range for the current animation will be used
     */
    export function getRandomIntervalTime(component: FarmEffectComponent): number {
        return getRandomWithinRange(component.intervalRange, getCurrentAnimationIndex(component));
    }

    /**
     * Gets random x offset within provided component's range
     *  - If applicable, the range for the current animation will be used
     */
    export function getRandomXOffset(component: FarmEffectComponent): number {
        return getRandomWithinRange(component.xOffsetRange, getCurrentAnimationIndex(component));
    }

    /**
     * Gets random y offset within provided component's range
     *  - If applicable, the range for the current animation will be used
     */
    export function getRandomYOffset(component: FarmEffectComponent): number {
        return getRandomWithinRange(component.yOffsetRange, getCurrentAnimationIndex(component));
    }

    /**
     * Gets random value from provided range/ranges
     *  - If more than one range is provided, the range for the current animation will be used
     *      - Defaults to first range provided if no range is found for the current animation
     */
    function getRandomWithinRange(ranges: ILimit | ILimit[], preferredIndex?: number): number {
        let range: ILimit;
        if (Array.isArray(ranges)) {
            range = ranges[Math.max(preferredIndex ?? 0, 0)];
        }
        else {
            range = ranges;
        }
        return Random.int(range?.min ?? 0, range?.max ?? 0);

    } 

    function getCurrentAnimationIndex(component: FarmEffectComponent): number {
        const animationName = component.gameObject.getComponent(DragonbonesComponent).animationName;
        return component.animationNames?.indexOf(animationName);
    }   
}
